import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiUrl } from '../config/api';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BuyUnitsModal from '../components/BuyUnitsModal';

export default function Settings() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [unitsBalance, setUnitsBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showBuyModal, setShowBuyModal] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const token = localStorage.getItem('token');
    try {
      const [balanceRes, historyRes] = await Promise.all([
        fetch(apiUrl('/api/units/balance'), { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(apiUrl('/api/units/history'), { headers: { 'Authorization': `Bearer ${token}` } })
      ]);
      const balanceData = await balanceRes.json();
      const historyData = await historyRes.json();
      setUnitsBalance(balanceData.balance || 0);
      setTransactions(historyData.transactions || []);
    } catch (e) {
      console.error('Failed to load data');
    }
    setLoading(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0a0f1c 0%, #1a1f35 100%)' }}>
      <Navbar />
      
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
        <h1 style={{ fontSize: '32px', fontWeight: '700', color: 'white', marginBottom: '8px' }}>Settings</h1>
        <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: '40px' }}>Manage your account and units</p>

        {/* Account Info */}
        <div style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '16px',
          padding: '24px',
          marginBottom: '24px'
        }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: 'white', marginBottom: '20px' }}>Account</h2>
          <div style={{ display: 'grid', gap: '16px' }}>
            <div>
              <label style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', display: 'block', marginBottom: '4px' }}>Email</label>
              <div style={{ color: 'white', fontSize: '16px' }}>{user?.email}</div>
            </div>
            <div>
              <label style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', display: 'block', marginBottom: '4px' }}>Name</label>
              <div style={{ color: 'white', fontSize: '16px' }}>{user?.name || 'Not set'}</div>
            </div>
          </div>
        </div>

        {/* Units Balance */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15), rgba(118, 75, 162, 0.15))',
          border: '1px solid rgba(102, 126, 234, 0.3)',
          borderRadius: '16px',
          padding: '24px',
          marginBottom: '24px'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h2 style={{ fontSize: '18px', fontWeight: '600', color: 'white', marginBottom: '8px' }}>Units Balance</h2>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '36px' }}>🪙</span>
                <span style={{ fontSize: '48px', fontWeight: '700', color: '#22c55e' }}>{unitsBalance}</span>
                <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '18px' }}>units</span>
              </div>
            </div>
            <button
              onClick={() => setShowBuyModal(true)}
              style={{
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                border: 'none',
                borderRadius: '12px',
                padding: '14px 28px',
                color: 'white',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Buy More Units
            </button>
          </div>
        </div>

        {/* Transaction History */}
        <div style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '16px',
          padding: '24px',
          marginBottom: '24px'
        }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: 'white', marginBottom: '20px' }}>Transaction History</h2>
          {loading ? (
            <div style={{ color: 'rgba(255,255,255,0.5)', textAlign: 'center', padding: '20px' }}>Loading...</div>
          ) : transactions.length === 0 ? (
            <div style={{ color: 'rgba(255,255,255,0.5)', textAlign: 'center', padding: '20px' }}>No transactions yet</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {transactions.slice(0, 20).map((tx, i) => (
                <div key={i} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px 16px',
                  background: 'rgba(255,255,255,0.02)',
                  borderRadius: '10px'
                }}>
                  <div>
                    <div style={{ color: 'white', fontSize: '14px' }}>{tx.description}</div>
                    <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '12px' }}>
                      {new Date(tx.created_at).toLocaleDateString()} {new Date(tx.created_at).toLocaleTimeString()}
                    </div>
                  </div>
                  <div style={{
                    color: tx.amount > 0 ? '#22c55e' : '#ef4444',
                    fontWeight: '600',
                    fontSize: '16px'
                  }}>
                    {tx.amount > 0 ? '+' : ''}{tx.amount}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Logout */}
        <button
          onClick={handleLogout}
          style={{
            width: '100%',
            padding: '14px',
            background: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            borderRadius: '12px',
            color: '#ef4444',
            fontSize: '15px',
            cursor: 'pointer'
          }}
        >
          Logout
        </button>
      </div>

      <Footer />

      {showBuyModal && (
        <BuyUnitsModal
          onClose={() => { setShowBuyModal(false); loadData(); }}
          currentBalance={unitsBalance}
        />
      )}
    </div>
  );
}
